import React, { createContext, useContext, ReactNode } from 'react';

import useProductsV2AndGqlProducts from '../hooks/useProductsV2AndGqlProducts';
import { ProductsV2ProductGridResponse } from '../types/gridResponses';

type ProductsV2ContextType = ProductsV2ProductGridResponse | undefined;

const ProductsV2Context = createContext<ProductsV2ContextType>(undefined);

interface ProductsV2ProviderProps {
  children: ReactNode;
}

export const ProductsV2Provider = ({ children }: ProductsV2ProviderProps) => {
  const productsV2Data = useProductsV2AndGqlProducts();

  return (
    <ProductsV2Context.Provider value={productsV2Data}>
      {children}
    </ProductsV2Context.Provider>
  );
};

export const useProductsV2Context = (): ProductsV2ContextType => {
  return useContext(ProductsV2Context);
};
